// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Tiz7","fullView":"styles_fullView__10-wI"};